import { httpClient } from "../http/httpClient";

export interface UpdateLeadPayload {
  link: string;
  cpf: string;
  name?: string;
  phone?: string;
  birthDate?: string;
  type?: string;
  value?: number;
}

export interface LeadHistoryItem {
  action: string;
  type?: string;
  value?: number;
  updatedAt: string;
}

export interface UpdateLeadResponse {
  _id: string;
  name: string;
  phone: string;
  cpf: string;
  link: string;
  history: LeadHistoryItem[];
}

export async function updateLead(payload: UpdateLeadPayload) {
  const { data } = await httpClient
    .put<UpdateLeadResponse>("/lead", payload)
    .catch((error) => {
      throw error.response?.data || error;
    });

  return data;
}
